import { createSelector } from 'reselect'
import isLoadingReduxUtil from 'modules/redux/utils/is-loading'
import isNewReduxUtil from 'modules/redux/utils/is-new'
import { getInstancesDomainUtil } from 'modules/redux/selectors/domain/utils'

/**
 * Gets the instances of the given `domainName`.
 * @param  {string} domainName
 * @returns {Selector}
 */
function getInstancesDomainSelector (domainName) {
  return createSelector(
    state => state[domainName],
    domain => getInstancesDomainUtil(domain)
  )
}

/**
 * Gets the new instance in the given domain.
 * @param  {string} domainName
 * @returns {Selector}
 */
function getNewInstanceDomainSelector (domainName) {
  return createSelector(
    state => state[domainName],
    domain => Object.values(domain.data || {}).find(value => isNewReduxUtil(value))
  )
}

/**
 * Checks whether the given domain's DomainListName is loading.
 * @param {string} domainName
 * @param {string} [domainListName='all']
 * @returns {boolean}
 */
function isDomainListLoadingDomainSelector (domainName, domainListName = 'all') {
  return createSelector(
    state => state[domainName],
    domain => isLoadingReduxUtil(domain[domainListName])
  )
}

export {
  getInstancesDomainSelector,
  getNewInstanceDomainSelector,
  isDomainListLoadingDomainSelector
}
